module.exports = __webpack_public_path__ + "img/icon-basicEduS-32.540bbab1.png";